import { createVNode as n, mergeProps as i } from "vue";
import f from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InfoOutlined.js";
import l from "../components/PfIcon.js";
const t = (o, r) => {
  const e = {
    ...o,
    ...r.attrs
  };
  return n(l, i(e, {
    icon: f
  }), null);
};
t.displayName = "InfoOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
